import e from "./_overArg.js";
var r = e, a = r(Object.keys, Object), v = a;
export {
  v as default
};
//# sourceMappingURL=_nativeKeys.js.map
